import { Button, Paper } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import VideoFrom from "../../components/form/VideoFrom";
import { useAddMovie, useUpdateMovie } from "../../utils/mutations";
import { useMoviesById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddMusicVideo = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const id = params.id;
  const page = searchParams.get("page") || "1";
  

  useEffect(() => {
    if (id && !user?.updateMovie) {
      notifications.show({ message: "You don't have permission to edit music videos", color: "red" });
      navigate(`/music-videos?page=${page}`);
    } else if (!id && !user?.addMovie) {
      notifications.show({ message: "You don't have permission to add music videos", color: "red" });
      navigate(`/music-videos?page=${page}`);
    }
  }, [id, user, navigate, page]);

  const { isPending, mutate } = useAddMovie();
  const { isPending: isUpdating, mutate: update } = useUpdateMovie({
    onSuccess: () => {
      navigate(`/music-videos?page=${page}`);
    },
  });
  const { data, isLoading } = useMoviesById(params.id);
  

  if (!user?.addMovie && !user?.updateMovie) {
    return null;
  }

  return (
    <>
      
      <Paper withBorder p="md"
        loading={isLoading}
        title={id ? "Edit Music Video" : "Add Music Video"}
        style={{
          maxWidth: "600px",
          width: "100%",
          marginInline: "auto",
        }}
      >
        <VideoFrom
          dataType="Music Video"
          onFinish={(values) => {
            if (id) {
              update({ id: id, data: values });
            } else {
              mutate(values);
            }
          }}
          update={data}
          submit={
            <Button
              type="submit"
              loading={isPending || isUpdating}
            >
              {id ? "Update" : "Add"}
            </Button>
          }
        />
      </Paper>
    </>
  );
};

export default AddMusicVideo;
